const state = {
  sessionId: '', //8a9d797b5f23404b40ba98d142373c3f,
  accessNum: '', // 19205710914
  channelId: 'cd_20220914_514144',
  emailInfo: {
    email: '',
    ifActivation: '0'
  },
  custName: null,
  phoneInfo: {}
}

const getters = {
  sessionId: state => state.sessionId,
  accessNum: state => state.accessNum,
  channelId: state => state.channelId,
  emailInfo: state => state.emailInfo,
  custName: state => state.custName,
  phoneInfo: state => state.phoneInfo,
}

const mutations = {
  set_sessionId(state, payload) {
    state.sessionId = payload
  },
  set_accessNum(state, payload) {
    state.accessNum = payload
  },
  set_channelId(state, payload) {
    state.channelId = payload
  },
  set_emailInfo(state, payload) {
    state.emailInfo = payload
  },
  set_custName(state, payload) {
    state.custName = payload
  },
  set_phoneInfo(state, payload) {
    state.phoneInfo = payload
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
